import { RiFlagFill, RiFlagLine } from '@remixicon/react';
import React from 'react';
import Hint from 'src/components/atoms/Hint';
import { AgButton } from 'src/components/ui';
import { AgButtonProps } from 'src/components/ui/AgButton';
import type { NotedOnId } from '../CommentsSection';
import NoteRequiredModal from './NoteRequiredModal';

export default function FlagButton({
  flagged,
  handleFlagChange,
  label,
  id,
  buttonProps = {},
  autoHandleCommentPost = true,
  'data-testid': dataTestId,
  confirmTestId,
  noteInputTestId,
}: {
  label?: string;
  flagged: boolean | null | undefined;
  handleFlagChange: (flagged: boolean, comment?: string) => Promise<unknown>;
  id?: NotedOnId;
  buttonProps?: AgButtonProps;
  autoHandleCommentPost?: boolean;
  'data-testid'?: string;
  confirmTestId?: string;
  noteInputTestId?: string;
}) {
  const [open, setOpen] = React.useState(false);

  const Icon = flagged ? RiFlagFill : RiFlagLine;

  const context = flagged ? `clear the flag from this order` : 'mark this order as flagged';

  const confirmLabel = flagged ? 'Clear Flag' : 'Flag';

  return (
    <>
      <Hint title="Flag">
        <AgButton
          variant="white"
          shape="rounded"
          {...buttonProps}
          onClick={() => setOpen(true)}
          data-testid={dataTestId}
        >
          <Icon size={16} />
        </AgButton>
      </Hint>
      {open && (
        <NoteRequiredModal
          headerLabel={label ? `Flagging ${label}` : 'Flagging'}
          contentText={`Are you sure you want to ${context}? If so, enter relevant notes below.`}
          confirmLabel={confirmLabel}
          open={open}
          external={false}
          autoHandleCommentPost={autoHandleCommentPost}
          onSubmit={async (comment) => {
            await handleFlagChange(!flagged, comment);
          }}
          handleClose={() => {
            setOpen(false);
          }}
          postCommentTo={id}
          confirmTestId={confirmTestId}
          noteInputTestId={noteInputTestId}
        />
      )}
    </>
  );
}
